import { GameLiveConnectionMethod, CommonConnectionsMethod } from './types';
import { BaseLiveConnection } from './BaseLiveConnection';
import { applicationStore } from '../../store/applicationStore';
import { userInfoStore } from '../../store/userInfoStore';
import { freeBetStore } from '../../store/freeBetStore';

export class GameLiveConnection extends BaseLiveConnection {
  constructor({ url }) {
    super(url);
  }

  // sendGetInitialState(getInitialParams) {
  //   return this.invoke(GameLiveConnectionMethod.GetInitialState, getInitialParams);
  // }

  sendGetInitialState(getInitialParams) {
    return new Promise((resolve) => {
      this.connection
        .invoke(GameLiveConnectionMethod.GetInitialState, getInitialParams)
        .then((data) => {
          resolve(data);
        })
        .catch(() => {
          applicationStore.setIsConnectionLost(true);
        });
    });
  }

  sendFreeBet(params) {
    return new Promise((resolve) => {
      this.connection.invoke(GameLiveConnectionMethod.AcceptFreebet, params).then((data) => {
        resolve(data);
      });
    });
  }

  ping(...args) {
    if (this.connection) {
      return this.connection.invoke(GameLiveConnectionMethod.Ping, ...args);
    }
    return null;
  }

  doBet(args, isSendAmount = true) {
    const { displayCurrency, exchangedBetAmount, betAmount } = userInfoStore;
    if (!applicationStore.isConnectionLost && this.connection) {
      const { currentFreeBet } = freeBetStore;
      if (isSendAmount) {
        return this.connection.invoke(GameLiveConnectionMethod.DoBet, {
          ...args,
          freebetId: currentFreeBet ? currentFreeBet.id : null,
          amount: displayCurrency ? exchangedBetAmount : betAmount,
        });
      }
      return this.connection.invoke(GameLiveConnectionMethod.DoBet, {
        ...args,
        freebetId: currentFreeBet ? currentFreeBet.id : null,
      });
    }
    return null;
  }

  checkHashResult(...args) {
    if (this.connection) {
      return this.connection.invoke(GameLiveConnectionMethod.CheckResultHash, ...args);
    }
    return null;
  }

  doSpin(args = {}, isSendAmount = true) {
    const { displayCurrency, exchangedBetAmount, betAmount } = userInfoStore;
    if (!applicationStore.isConnectionLost && this.connection) {
      const { currentFreeBet } = freeBetStore;
      if (isSendAmount) {
        return this.connection.invoke(GameLiveConnectionMethod.DoSpin, {
          ...args,
          freebetId: currentFreeBet ? currentFreeBet.id : null,
          spinData: {
            ...args.spinData,
            amount: displayCurrency ? exchangedBetAmount : betAmount,
          },
        });
      }

      return this.connection.invoke(GameLiveConnectionMethod.DoSpin, {
        ...args,
        freebetId: currentFreeBet ? currentFreeBet.id : null,
      });
    }
    return null;
  }

  onGetInitialStateResult(callback) {
    return this.on(GameLiveConnectionMethod.GetInitialStateResult, (data) => {
      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.GetInitialStateResult,
        data,
        callback,
      });
    });
  }

  onHandleUnauthorizedError(callback) {
    return this.on(GameLiveConnectionMethod.Error, (data) => {
      if (callback) {
        callback(data);
      }

      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.Error,
        data,
      });
    });
  }

  onDoBetResult(callback) {
    return this.on(GameLiveConnectionMethod.DoBetResult, (data) => {
      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.DoBetResult,
        data,
      });

      if (callback) {
        callback(data);
      }
    });
  }

  onReportStateResult(callback) {
    return this.on(GameLiveConnectionMethod.ReportStateResult, (data) => {
      if (callback) {
        callback(data);
      }
      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.ReportStateResult,
        data,
      });
    });
  }

  onDoSpinResult(callback) {
    return this.on(GameLiveConnectionMethod.DoSpinResult, (data) => {
      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.DoSpinResult,
        data,
      });

      if (callback) {
        callback(data);
      }
    });
  }

  onCashOutResult(callback) {
    return this.on(GameLiveConnectionMethod.CashOutResult, (data) => {
      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.CashOutResult,
        data,
      });
      if (callback) {
        callback(data);
      }
    });
  }

  onDoBetResultValidation(callback) {
    return this.on(GameLiveConnectionMethod.DoBetResultValidation, callback);
  }

  onRoundFinished(callback) {
    return this.on(GameLiveConnectionMethod.RoundFinished, (data) => {
      if (callback) {
        callback(data);
      }
      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.RoundFinished,
        data,
      });
    });
  }

  onRoundStarted(callback) {
    return this.on(GameLiveConnectionMethod.RoundStarted, (data) => {
      if (callback) {
        callback(data);
      }
      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.RoundStarted,
        data,
      });
    });
  }

  onResultReport(callback) {
    return this.on(GameLiveConnectionMethod.ResultReport, callback);
  }

  onMaintenanceNotify(callback) {
    return this.on(GameLiveConnectionMethod.MaintenanceNotify, (data) => {
      if (callback) {
        callback(data);
      }

      this.callbackMiddleware({
        methodName: CommonConnectionsMethod.UnderMaintenance,
        data,
      });
    });
  }

  onBalanceUpdate(callback) {
    return this.on(GameLiveConnectionMethod.BalanceUpdate, (data) => {
      if (callback) {
        callback(data);
      }

      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.BalanceUpdate,
        data,
      });
    });
  }

  onPing(callback) {
    return this.on(GameLiveConnectionMethod.Ping, callback);
  }

  onBetsClosed(callback) {
    return this.on(GameLiveConnectionMethod.BetsClosed, callback);
  }

  onGameOpen(callback) {
    return this.on(GameLiveConnectionMethod.GameOpen, (data) => {
      if (callback) {
        callback(data);
      }

      this.callbackMiddleware({
        methodName: GameLiveConnectionMethod.GameOpen,
        data,
      });
    });
  }
}
